import { useFieldContext } from '@zealth/core/form/contexts'
import type { SegmentedControlFormFieldProps } from '@zealth/core/formFields/types'

import { SegmentedControl } from '@/ui/components/SegmentedControl'

export { type SegmentedControlFormFieldProps }

export const SegmentedControlFormField = ({
  label,
  options,
}: SegmentedControlFormFieldProps) => {
  const field = useFieldContext<string>()

  return (
    <SegmentedControl
      label={label ?? ''}
      options={options}
      value={field.state.value}
      onChange={field.handleChange}
    />
  )
}
